/**
 * Created by nijin on 2/2/17.
 */
import {Component, OnInit, Input, OnChanges, ViewChildren} from '@angular/core';
import {FormGroup, Validators, FormBuilder} from '@angular/forms';
import {GlobalValidator} from '../../shared/validators/global-validator';
import {EntityService} from "../../core/entity.service";

@Component({
    selector: 'nuc-edit-attribute',
    templateUrl: './edit-attribute.component.html',
    styles: [
      `
         .help-block{
         font-size: 12px;
         }
       `
    ]

})
export class EditAttributeComponent implements OnInit, OnChanges {
  showCreateForm = false;
  form: FormGroup;
  isSubmitted = false;
  selectedAttribute: Array<number> = [];
  @Input() attributes;
  @Input() dataTypes = [];
  @Input() isMobileApp = false;
  @ViewChildren('attributeRow') attributeRows;
  onEdit: boolean;

  formErrors = {
    'name': '',
    'datatype': '',
    'precision': '',
    'unit': ''
  };
  validationMessages = {
    'name': {
      'required': 'VALIDATIONS.LOCATION.NAME.REQUIRED',
      'maxlength': 'VALIDATIONS.LOCATION.NAME.MAX_LENGTH',
      'jsonKey': 'VALIDATIONS.LOCATION.NAME.NO_SPECIAL_CHARACTERS',
    },
    'datatype': {
      'required': 'VALIDATIONS.LOCATION.DATA_TYPE.REQUIRED'
    },
    'precision': {
      'invalidRange': 'VALIDATIONS.LOCATION.PRECISION.NUMERIC',
    },
    'unit': {
      'required': 'VALIDATIONS.LOCATION.UNIT.REQUIRED',
      'maxlength': 'VALIDATIONS.LOCATION.UNIT.MAX_LENGTH',
      'consecutiveSpace': 'CMN_VALIDATIONS.CONSECUTIVE_SPACE',
      'minlength': 'CMN_VALIDATIONS.MIN_LENGTH_TWO',
      'onlySpace': 'VALIDATIONS.LOCATION.UNIT.ONE_NON_SPACE'

    }
  };

  constructor(private fb: FormBuilder, private entityService: EntityService) {
  }


  ngOnInit() {
    this.buildForm();
  }

  ngOnChanges() {
    if (this.showCreateForm) {
      this.discardChanges();
    }

  }

  buildForm() {
    this.form = this.fb.group(
      {
        'name': ['', [
          Validators.required,
          Validators.maxLength(50),
          GlobalValidator.jsonKeyValidation
        ]
        ],
        'datatype': ['', [
          Validators.required,
        ]
        ],
        'unit': ['', [
          Validators.maxLength(50),
          Validators.required
        ]
        ],
        'precision': ['', [
          GlobalValidator.numberBetween(0, 100)

        ]
        ],
        'required': [0, []
        ],
      }
    );
    this.form.valueChanges
      .subscribe(data => this.onValueChanged(data));
  }

  addAttribute(form) {
    if (!form.valid) {
      this.isSubmitted = true;
      this.onValueChanged();
      return;
    }
    let attributeNames = this.attributes.map((attr) => {
      return attr.name;
    });
    let attrName = form.controls['name'].value;

    if (attributeNames.indexOf(attrName) > -1) {
      this.isSubmitted = true;
      this.formErrors.name = 'VALIDATIONS.LOCATION.NAME.ALREADY_ADDED';
      return;
    }

    this.attributes.unshift(form.value);
    this.discardChanges();

  }

  discardChanges() {
    this.isSubmitted = false;
    this.form.reset();
    this.showCreateForm = false;
  }

  selectAttribute({isSelect:isSelect, attribute: attribute}) {
    if (isSelect) {
      this.selectedAttribute.push(attribute);
    } else {
      let idx = this.selectedAttribute.indexOf(attribute);
      this.selectedAttribute.splice(idx, 1);
    }
  }

  deleteAttribute() {
    this.selectedAttribute.forEach((item) => {
      let idx = this.attributes.indexOf(item);
      this.attributes.splice(idx, 1);
    });
    this.selectedAttribute = [];
  }

  onValueChanged(data?: any) {
    if (!this.form) {
      return;
    }
    const form = this.form;
    for (const field in this.formErrors) {
      // clear previous error message (if any)
      this.formErrors[field] = '';
      const control = form.get(field);
      if (control && !control.valid) {
        const messages = this.validationMessages[field];
        for (const key in control.errors) {
          this.formErrors[field] = messages[key];
        }
      }
    }
  }

  copyAttribute({attribute: attribute, index: index}) {
    if(!attribute) {
      return;
    }
    let attributeCopy = this.entityService.clone(attribute);
    attributeCopy.name = this.getAttributeCopyName({name: attribute.name});

    this.attributes.splice(index+1, 0, attributeCopy);
  }

  updateAttribute({attribute: attribute, index: index}) {
    if(!attribute) {
      return;
    }
    this.attributes[index] = attribute;
  }

  private getAttributeCopyName({name: name}) {
    let pattern = `${name}-copy-[\\d]*$`;
    let regex =  new RegExp(pattern);
    let items = this.attributes.filter(item => regex.test(item.name));
    return `${name}-copy-${items.length}`;
  }

  filterInputNumber(event) {
    let keyCode = ('which' in event) ? event.which : event.keyCode;
    let isNotWanted = (keyCode === 69 || keyCode === 101 || keyCode === 43 || keyCode === 45 || keyCode === 46);
    return !isNotWanted;
  }

  discardAllChanges() {
    this.attributeRows.forEach((item, index) => {
      item.discardEditing();
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/schema/edit-schema/edit-attribute.component.ts